export const masonry = (masonry) => {
  let $masonry;

  const init = () => {

    $masonry = $(masonry).masonry({
       itemSelector: '.masonry-item',
       horizontalOrder: 'true'
    });

  };

  if ($(masonry).length > 0) {
    init();
  }

};
